"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ViewSquare: ['view-square', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M4.267,10.722a1.825,1.825,0,0,0,0,2.544C5.818,14.821,8.591,17.25,12,17.25s6.183-2.428,7.735-3.983a1.825,1.825,0,0,0,0-2.544C18.182,9.168,15.406,6.739,12,6.739S5.819,9.166,4.267,10.722Z', 'M9.750 11.991 A2.250 2.250 0 1 0 14.250 11.991 A2.250 2.250 0 1 0 9.750 11.991 Z']],
  ViewCircle: ['view-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M4.267,10.731a1.825,1.825,0,0,0,0,2.544C5.818,14.83,8.591,17.258,12,17.258s6.182-2.427,7.734-3.982a1.826,1.826,0,0,0,0-2.544C18.183,9.177,15.406,6.748,12,6.748S5.819,9.175,4.267,10.731Z', 'M9.750 12.000 A2.250 2.250 0 1 0 14.250 12.000 A2.250 2.250 0 1 0 9.750 12.000 Z']],
  ViewOff: ['view-off', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.783 21L21.533 3', 'M8.964,19.051A9.985,9.985,0,0,0,12,19.5c4.1.069,8.258-2.813,10.824-5.637a1.663,1.663,0,0,0,0-2.226,20.568,20.568,0,0,0-3.074-2.757', 'M14.413,6.282A9.549,9.549,0,0,0,12,6C7.969,5.933,3.8,8.752,1.179,11.635a1.663,1.663,0,0,0,0,2.226,20.8,20.8,0,0,0,2.6,2.4', 'M8.25,12.75A3.749,3.749,0,0,1,12,9', 'M15.75,12.749h0A3.75,3.75,0,0,1,12,16.5']],
  View1: ['view-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,5.251C7.969,5.183,3.8,8,1.179,10.885a1.663,1.663,0,0,0,0,2.226C3.743,15.935,7.9,18.817,12,18.748c4.1.069,8.258-2.813,10.824-5.637a1.663,1.663,0,0,0,0-2.226C20.2,8,16.031,5.183,12,5.251Z', 'M15.75,12A3.75,3.75,0,1,1,12,8.249,3.749,3.749,0,0,1,15.75,12Z']],
  Binocular: ['binocular', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 18.000 A4.500 4.500 0 1 0 9.750 18.000 A4.500 4.500 0 1 0 0.750 18.000 Z', 'M9.75,18V4.125a2.625,2.625,0,0,0-5.156-.7L.911,16.805', 'M14.250 18.000 A4.500 4.500 0 1 0 23.250 18.000 A4.500 4.500 0 1 0 14.250 18.000 Z', 'M14.25,18V4.125a2.625,2.625,0,0,1,5.156-.7l3.683,13.377', 'M9.75 9H14.25V12H9.75z']],
  ViewCircle1: ['view-circle-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M12,7.772C9.313,7.728,6.533,9.55,4.786,11.415a1.051,1.051,0,0,0,0,1.439C6.5,14.68,9.264,16.543,12,16.5c2.736.044,5.5-1.819,7.216-3.645a1.051,1.051,0,0,0,0-1.439C17.467,9.55,14.687,7.728,12,7.772Z', 'M10.500 12.135 A1.500 1.500 0 1 0 13.500 12.135 A1.500 1.500 0 1 0 10.500 12.135 Z']]
};
exports["default"] = _default;